import validateForm_1 from "./1_validator";
import validateForm_2 from "./2_validator";
import validateFrom_4 from "./4_validator";

export default function validateForm (formType, invoiceData, templates = []) {
    switch (formType) {
        case 0:
            return validateForm_1(invoiceData, templates);
        case 1:
            return validateForm_2(invoiceData);
        case 3:
            return validateFrom_4(invoiceData);
        default:
            return {};
    }
}